import { z } from 'zod';

import { EmailStringSchema } from '../../common';
import { makeEndpoint } from '../common';

export const LiveStatusSchema = z.object({
  brandId: z.string().uuid(),
  live: z.boolean(),
  enforcedBy: z
    .object({
      id: z.string().uuid(),
      firstName: z.string(),
      lastName: z.string(),
      emailAddress: EmailStringSchema,
    })
    .nullable(),
  updatedAt: z.string().datetime(),
});

export type LiveStatus = z.infer<typeof LiveStatusSchema>;

export const LiveStatusWithBreakdownSchema = LiveStatusSchema.extend({
  isScriptEmbedded: z.boolean().nullable(),
  isBankAccountConnected: z.boolean().nullable(),
  isBrandInfoSet: z.boolean().nullable(),
  bookableExperiencesCount: z.number().nullable(),
});

export type LiveStatusWithBreakdown = z.infer<typeof LiveStatusWithBreakdownSchema>;

export const LiveStatusResponseSchema = LiveStatusSchema;

export type LiveStatusResponse = z.infer<typeof LiveStatusResponseSchema>;

export const GetBrandLiveStatusEndpoint = makeEndpoint({
  method: 'GET',
  url: (params: { brandId: string }) => `/brands/${params.brandId}/live-status`,
  requestSchema: z.void(),
  responseSchema: LiveStatusResponseSchema,
});

export const RefreshBrandLiveStatusEndpoint = makeEndpoint({
  method: 'POST',
  url: (params: { brandId: string; force?: boolean }) =>
    `v1/brands/${params.brandId}/live-status/refresh?${params.force ? 'force=true' : ''}`,
  requestSchema: z.void(),
  responseSchema: LiveStatusResponseSchema,
});

export const PutLiveStatusRequestSchema = z.object({
  live: z.boolean(),
});

export type PutLiveStatusRequest = z.infer<typeof PutLiveStatusRequestSchema>;

export const PutBrandLiveStatusEndpoint = makeEndpoint({
  method: 'PUT',
  url: (params: { brandId: string }) => `/brands/${params.brandId}/live-status`,
  requestSchema: PutLiveStatusRequestSchema,
  responseSchema: LiveStatusResponseSchema,
});
